































import { Component, Inject, Watch, Mixins } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import { notificationsRoutes } from './router';
import { isViewedEvent } from './index';
import { LoaderMixin } from '@/pages/profile/mixins';
import { Button, SelectCount } from '@/pages/profile/components';
import { MenuData, Menu as InnerMenu } from '@/pages/profile/blocks';
import Infotext from '@/components/parts/infotext';
import { notificationsService } from '@/services';
import { countNotifications } from './consts';

@Component({
  components: {
    Button,
    InnerMenu,
    Infotext,
    SelectCount,
  },
})
export default class Notifications extends Mixins(LoaderMixin) {
  @Inject() $api: AxiosInstance;

  readonly menu: MenuData = notificationsRoutes;
  readonly limits: Array<string> = countNotifications;
  notifications: Array<any> = [];
  errorMessage: string = '';
  notificationsLimit: string = '10';

  get notificationsLimits() {
    return this.limits.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }

  @Watch('$route', { immediate: true })
  refreshData() {
    this.getData();
  }

  async getData(): Promise<void> {
    this.setStatus('loading');
    try {
      const { data } = await notificationsService(this.$api).getNotifications(
        this.notificationsLimit,
      );
      this.notifications = data;
      this.setStatus('success');
    } catch (err) {
      if (err.response.data && err.response.data.errors) {
        const [{ msg }] = err.response.data.errors;
        this.errorMessage = msg;
      }
      this.setStatus('error');
    }
  }

  async postData(id: string): Promise<void> {
    if (!id) return;
    try {
      await notificationsService(this.$api).postNotification(id);
      isViewedEvent.event = true;
    } catch (err) {
      if (err.response.data && err.response.data.errors) {
        const [{ msg }] = err.response.data.errors;
        this.errorMessage = msg;
      }
      this.setStatus('error');
    }
  }

  closeMessages() {
    this.errorMessage = '';
    this.setStatus('success');
  }

  notificationsLimitChange(value: string) {
    this.notificationsLimit = value;
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/notification/Index.vue